// WholesellerForm.js

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Form from "../../../../components/forms/index";
import { FailedNotify, SuccessNotify } from "../../../../constants/tostify";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import {
  useCreateShopMutation,
  useGetShopCategoriesQuery,
  useCheckShopLimitQuery,
} from "../../../../features/shop/shopApiSlice";
import Subscriptionmdl from "../../../../components/subscription_modal/index";

const WholesellerForm = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);

  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [displayimg, setDisplayimg] = useState();

  // Subscription modal state
  const [lgShow, setLgShow] = useState(false);
  const [purchase, setPurchase] = useState(false);

  // RTK Query: fetch categories
  const { data: categoriesData } = useGetShopCategoriesQuery({
    type: "wholesellerShop",
    parentCategory: "",
  });
  const shopCategoryone = categoriesData?.data?.Category || [];

  // RTK Query: create shop mutation
  const [createShopMutation, { isLoading: isloading }] = useCreateShopMutation();

  // RTK Query: check shop limit
  const { data: limitData, isLoading: isLimitLoading } = useCheckShopLimitQuery(name?._id, {
    skip: !name?._id,
  });

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });

      setCreateShop((createShop) => ({
        ...createShop,
        image: abc,
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [selectshop, setSelectshop] = useState({ shopCategory: "" });
  const Shopdatas = (e) => {
    setSelectshop((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryid = selectshop?.shopCategory[0];
  const [createShop, setCreateShop] = useState({
    userid: name._id,
    shopname: "",
    shopaddress: "",
    shoplicense: "",
    contact: "",
    image: [""],
    isFoodShop: false,
    marketPlace: "",
    shopCategory: "",
    businessType: "wholesellerShop",
    description: "",
    status: true,
    latitude: "",
    longitude: "",
  });

  useEffect(() => {
    setCreateShop((createShop) => ({
      ...createShop,
      shopCategory: categoryid,
    }));
  }, [categoryid]);

  const PostShopData = async (e) => {
    e.preventDefault();

    if (limitData && !limitData.canCreate) {
      FailedNotify(`Shop creation limit reached. You can only create up to ${limitData.maxAllowedShops} shops on your current plan.`);
      setLgShow(true);
      return;
    }

    let finalCreateShop = { ...createShop };

    // If coordinates are missing, try to resolve them from the text address
    if ((!finalCreateShop.latitude || !finalCreateShop.longitude) && finalCreateShop.shopaddress) {
      try {
        const geocodeRes = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(finalCreateShop.shopaddress)}&format=json&limit=1`
        );
        const geocodeData = await geocodeRes.json();
        if (geocodeData && geocodeData.length > 0) {
          finalCreateShop.latitude = parseFloat(geocodeData[0].lat);
          finalCreateShop.longitude = parseFloat(geocodeData[0].lon);
        }
      } catch (err) {
        console.error("Failed to automatically geocode address:", err);
      }
    }

    try {
      const response = await createShopMutation(finalCreateShop).unwrap();
      if (response?.success) {
        setTimeout(() => {
          SuccessNotify("Form Created wholeseller Successfully");
          navigate(`/wholsaler-bussines-Profile/${response?.data?._id}`);
        }, 1000);
      }
    } catch (error) {
      // Display specific backend error message
      const backendMessage =
        error?.data?.message ||
        error?.message ||
        "Failed To Create Shop. Please try again.";
      FailedNotify(backendMessage);
    }
  };

  if (isloading || isLimitLoading) {
    return <Loader heightsetting="screenHeight" />;
  }

  return (
    <>
      <Subscriptionmdl
        lgShow={lgShow}
        setLgShow={setLgShow}
        setPurchase={setPurchase}
        purchase={purchase}
      />
      <Form
        title="Fill to Create WholeSeller Shop"
        butn="Create"
        back="/wholeseller-integrate"
        CreateHandler={PostShopData}
        setCreateShop={setCreateShop}
        createShop={createShop}
        shopCategoryone={shopCategoryone}
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        displayimg={displayimg}
        setDisplayimg={setDisplayimg}
        Shopdatas={Shopdatas}
        isUploading={isUploading}
        uploadProgress={uploadProgress}
      />
    </>
  );
};

export default WholesellerForm;
